import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ProductionVolume, ProductionVolumeEntity} from "../../../model/production-volume";

export interface ProductionVolumeSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<ProductionVolumeSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const productionVolumesSelector = () => createSelector(
  [getUseQueryResultData<ProductionVolume[]>, getRegionIdParam],
  (data, regionId) => {
    return selectProductionVolumesAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const productionVolumeSelector = () => createSelector(
  [getUseQueryResultData<ProductionVolume>],
  (data) => {
    return data ? transformProductionVolume(data) : undefined;
  }
);

export const selectProductionVolumes = (values?: ProductionVolume[], selector?: ProductionVolumeSelectorProps): ProductionVolume[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformProductionVolume = (value: ProductionVolume): ProductionVolumeEntity => {
  return ProductionVolumeEntity.from(value)
}

export const selectProductionVolumesAndTransform = (values?: ProductionVolume[], selector?: ProductionVolumeSelectorProps): ProductionVolumeEntity[] => {
  const selected = selectProductionVolumes(values, selector);
  return selected.map(transformProductionVolume);
};
